import { instance } from '../../config/intercepter';

export const getInvoicesFn = async ({ period = 'custom', month, year }) => {
  const response = await instance.get(
    `api/invoices?period=${period}&month=${month}&year=${year}`
  );
  return response.data;
};

export const downloadInvoice = async (invoice) => {
  let postData = { invoice: invoice };
  instance.post(
    `/api/downloadinvoice`,
    postData,
    {
      responseType: 'arraybuffer',
    }
  ).then(response => {
    try {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
    } catch (e) {
      console.log(e);
    }
  });
  
  
}